import { Controller } from "@hotwired/stimulus"

// 表示ページの見出し (h1-h5[id]) 右側にリンクコピーボタン (🔗) を出す。
// クリックで `<origin><path>#<id>` を clipboard にコピーし、一瞬 ✓ を表示。
export default class extends Controller {
  connect() {
    this.element.querySelectorAll("h1[id], h2[id], h3[id], h4[id], h5[id]").forEach((h) => {
      if (h.querySelector(".akebono-heading-anchor")) return
      h.classList.add("akebono-has-anchor")
      const btn = document.createElement("button")
      btn.type = "button"
      btn.className = "akebono-heading-anchor"
      btn.title = "リンクをコピー"
      btn.setAttribute("aria-label", "見出しへのリンクをコピー")
      btn.textContent = "🔗"
      btn.addEventListener("click", (e) => {
        e.preventDefault()
        this.copy(h.id, btn)
      })
      h.appendChild(btn)
    })
  }

  copy(id, btn) {
    const url = `${location.origin}${location.pathname}#${encodeURIComponent(id)}`
    const done = () => {
      const prev = btn.textContent
      btn.textContent = "✓"
      setTimeout(() => { btn.textContent = prev }, 1200)
    }
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(() => this.fallbackCopy(url, done))
    } else {
      this.fallbackCopy(url, done)
    }
    // アドレスバーにも反映 (リロードせず)
    history.replaceState(null, "", `#${id}`)
  }

  fallbackCopy(text, done) {
    const ta = document.createElement("textarea")
    ta.value = text
    ta.style.position = "fixed"
    ta.style.opacity = "0"
    document.body.appendChild(ta)
    ta.select()
    try { document.execCommand("copy"); done() } catch (_) {}
    ta.remove()
  }
}
